import React, { useEffect } from "react";
import {
  BiChart,
  BiChat,
  BiCricketBall,
  BiHome,
  BiListCheck,
  BiShare,
} from "react-icons/bi";
import { Outlet, useNavigate } from "react-router-dom";
import { walletBal } from "../ApiServices/Apifun";
import { useDispatch } from "react-redux";
import { setWalletBalance, setWithdrawAmount } from "../Store/B2bslice";
import { getLocalStorageItem } from "../Utils";
import { MdGames } from "react-icons/md";

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const getWallletBal = () => {
  //   walletBal()
  //     .then((res) => {
  //       if (res.status) {
  //         dispatch(setWalletBalance(res.data?.availableWalletAmt));
  //         dispatch(setWithdrawAmount(res.data?.withdrawableAmount));
  //       }
  //     })
  //     .catch((err) => console.log(err));
  // };
  // useEffect(() => {
  //   getWallletBal();
  //   //eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  const accessToken = getLocalStorageItem("accessToken");

  return (
    <>
      {/* <img src={Images.Logo} className="w-[100px] flex justify-center items-center mt-2 m-auto" alt="logo" /> */}
      <div className="w-[480px] max-w-full md:px-0 m-auto ">
        {" "}
        <Outlet />
      </div>
      <div></div>
      {/* 
      <FloatButton
        shape="circle"
        icon={<BiSupport />} 
        style={{
          right: 54,
        }}
        onClick={() => navigate("/support")}
        className="bg-[#fba037]  mr-96 mb-14 "
      /> */}
      <div
        className="grid grid-cols-5 w-auto sm:w-[480px] m-auto bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f]
             text-white fixed bottom-0 left-0 right-0 py-2  items-center"
      >
        <div
          onClick={() => navigate(accessToken ? "/match" : "/")}
          className="flex cursor-pointer justify-center items-center flex-col"
        >
          <BiCricketBall color="white" size={20} />
          <p className="text-white font-semibold text-sm">Match</p>
        </div>

        <div
          onClick={() => navigate(accessToken ? "/chart" : "/")}
          className="flex cursor-pointer justify-center items-center flex-col"
        >
          <BiChart color="white" size={20} />
          <p className="text-white font-semibold text-sm">Chart</p>
        </div>
        <div className="relative flex justify-center items-center">
          <div
            onClick={() => navigate(accessToken ? "/home" : "/")}
            className="  flex cursor-pointer justify-center items-center flex-col text-white font-semibold text-sm w-16 h-16 bg-[#ba7d13] rounded-full shadow-xl shadow-[#734e0c] transform transition duration-300 hover:scale-105 hover:shadow-2xl active:scale-95"
          >
            <BiHome size={28} />
            <p className="text-white font-semibold text-sm">Home</p>
          </div>
        </div>
        {/* <div className="absolute -top-6 w-16 h-16 bg-[#ba7d13] rounded-full shadow-xl shadow-[#734e0c] flex justify-center items-center flex-col cursor-pointer transition-transform hover:scale-105 active:scale-95"></div> */}

        <div
          onClick={() => navigate(accessToken ? "/allGame" : "/")}
          className="flex cursor-pointer justify-center items-center flex-col"
        >
          <MdGames color="white" size={20} />
          <p className="text-white font-semibold text-sm">Games</p>
        </div>

        <div
          onClick={() => navigate(accessToken ? "/share" : "/")}
          className="flex cursor-pointer justify-center items-center flex-col"
        >
          <BiShare color="white" size={20} />
          <p className="text-white font-semibold text-sm">Share</p>
        </div>
      </div>
    </>
  );
};

export default Layout;
